<template>
    <div>
        <card-header title="Edit Registration" icon="fa-pencil"/>

        <card-body>
            <registration-form v-if="registration.id" :registration="registration"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
<!--                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteType"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Type?</span></b-button>-->
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!registration.conf_reg_types"
                    ><i class="fas fa-check mr-2"></i>Save Registration
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import RegistrationForm from "./RegistrationForm";

    export default {
        components: {RegistrationForm, RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                registration: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadReg: function(force) {
                this.$emit('loading', true);
                http.get('registrations/' + this.props.regId, {force}).then(response => {
                    this.registration = response.data;
                    this.$emit('loading', false);
                });
            },
            submit: function() {
                http.put('registrations/' + this.props.regId, {
                    reg_type_id: this.registration.conf_reg_types.id,
                }, {force: true}).then(response => {
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the registration.');
                    this.$emit('loading', false);
                });
            },
            // deleteType() {
            //     if (this.confirmDelete) {
            //         this.$emit('loading', true);
            //
            //         http.delete('conferences/' + this.props.confId + '/types/' + this.type.id).then(response => {
            //             this.$reloadCard('conf-reg-types', {confId: this.props.confId});
            //             this.$saveAlert(false);
            //             this.$closeCard(this.card);
            //         }).catch(err => {
            //
            //         });
            //     } else {
            //         this.confirmDelete = true;
            //         setTimeout(() => {
            //             this.confirmDelete = false;
            //         }, 3000);
            //     }
            // }
        },
        watch: {
            'props.regId': function() {
                this.dirty = null;
                this.loadReg();
            },
            'registration': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this registration? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadReg();
        }
    };
</script>
